/**
 * What "Clear filters" resets the search filters to.
 *
 * Extracted from SearchProvider so the rule is testable: it used to preserve
 * `hasPointsRates` and `isRefundable` across a clear, on the grounds that they
 * were "UI toggle preferences excluded from the Clear Filters visibility check".
 * That stopped being true once they became rate-type filters counted by
 * `panelFiltersActiveLabel` and `hasActiveFilters` — clearing left the `Filter
 * (1)` badge and the Clear filters pill on screen with nothing left to clear, so
 * the button appeared to do nothing on every subsequent press.
 *
 * `showUnavailable` genuinely is a display preference (nothing counts it as an
 * active filter), so it is still carried across.
 */

export function buildClearedFilters<
  T extends { showUnavailable?: boolean } | undefined,
>(previous: T, initial: { showUnavailable?: boolean }): typeof initial {
  const cleared = { ...initial };
  if (previous?.showUnavailable !== undefined) {
    cleared.showUnavailable = previous.showUnavailable;
  }
  return cleared;
}
